import { Button, Slider, Typography } from '@pwskills/rachnaui';
import React, { useEffect, useState } from 'react';
import { ICertificateType } from '@/interfaces/courseDescription';
import { useRouter } from 'next/router';
import CertificateSection from './CertificateSection';

type Props = {
  certificateType: ICertificateType[] | undefined;
  setCertificate: React.Dispatch<React.SetStateAction<string>>;
  certificate: string;
  setModelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isAmateur: boolean;
};

const RenderTitle = ({
  certificateType,
  activeTab,
  setActiveTab,
  setCertificate,
}: {
  certificateType: ICertificateType[] | undefined;
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  setCertificate: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  return (
    <div className="flex justify-center medium:!justify-start gap-x-6 w-full">
      {certificateType?.map(({ name, certificateImage }) => (
        <Button
          variant="text"
          className="!p-0 shrink-0"
          onClick={() => {
            setActiveTab(name);
            setCertificate(certificateImage);
          }}
          key={name}
        >
          <Typography
            component={isDashboard ? 'body-small' : 'subheading'}
            variant="regular"
            className={
              (activeTab === name && 'text-gray-900 underline underline-offset-[6px] !font-bold') ||
              'min-w-fit text-gray-650'
            }
          >
            {name}
          </Typography>
        </Button>
      ))}
    </div>
  );
};

const TabContent = ({ activeTabData }: { activeTabData: ICertificateType | undefined }) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(activeTabData?.description || '', 'text/html');
  const description = doc.body.getElementsByTagName('strong');
  Array.from(description).forEach((desc) => {
    desc.setAttribute('class', 'text-gray-900');
  });
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  return (
    <div className="flex gap-y-[40px] flex-col">
      <Typography
        component={isDashboard ? 'body-small' : 'subheading'}
        variant={isDashboard ? 'semi-bold' : 'bold'}
        className="flex justify-center medium:!justify-start text-gray-650"
      >
        <span
          dangerouslySetInnerHTML={{
            __html: doc.body.innerHTML || '',
          }}
        />
      </Typography>
      <div className="flex justify-center medium:!justify-start text-gray-650">
        <ul className="list-disc ml-4">
          {activeTabData?.points?.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const SelectionTabs = ({
  setCertificate,
  certificateType,
  certificate,
  setModelOpen,
  isAmateur,
}: Props) => {
  const [activeTab, setActiveTab] = useState<string>(certificateType?.[0]?.name || '');
  const activeTabData = certificateType?.find(({ name }) => name === activeTab);

  useEffect(() => setActiveTab(certificateType?.[0]?.name || ''), [certificateType]);
  const router = useRouter();
  const isDashboard = router.pathname.includes('/dashboard');
  return (
    <div className="flex flex-col gap-[24px] w-full">
      {!isDashboard && (
        <div className="medium:!hidden">
          <CertificateSection
            certificate={certificate}
            setModelOpen={setModelOpen}
            isAmateur={isAmateur}
          />
        </div>
      )}

      <Slider
        className="justify-center medium:!justify-start !min-w-[50vw]"
        iconWrapperClass="hidden"
        positionOfSliderInMobile="bottom"
      >
        <RenderTitle
          certificateType={certificateType}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setCertificate={setCertificate}
        />
      </Slider>
      <TabContent activeTabData={activeTabData} />
    </div>
  );
};

export default SelectionTabs;
